// import gstImg from '../../images/services/gst-compliance.jpg';
import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const GSTComplianceLitigation = () => {
  const serviceData = {
    title: "GST Compliance & Litigation Support",
    heading: "GST Compliance & Litigation Support",
    image: subTopicImages["GST Compliance & Litigation Support"],
    intro:
      "Complete GST life-cycle support — from registration to dispute resolution",
    description: [
      "Goods & Services Tax (GST) is one of the most significant reforms in India’s tax framework. While it has simplified the indirect tax structure, it has also introduced stringent reporting rules, technology-driven scrutiny and frequent regulatory updates. Businesses today must maintain accuracy, documentation discipline and timely filing — while also being fully prepared for departmental audits, assessments and litigation.",
      "At V DOOGAR AND ASSOCIATES, we act as a dedicated GST partner for businesses, ensuring organisations remain fully compliant, audit-ready and legally protected. Our GST team provides end-to-end advisory, compliance management, departmental representation and litigation support — helping companies minimise exposure and maintain strong tax governance.",
      "We support Indian businesses, subsidiaries of multinationals, exporters, manufacturers, service companies and trading organisations across India.",
    ],
    services: [
      {
        title: "GST Registration & Onboarding",
        text: "We assist with:",
        list: [
          "GST registration advisory",
          "entity and location-wise registration planning",
          "onboarding and system setup",
        ],
        extraInfo: "Ensuring correct registration and smooth GST initiation.",
      },
      {
        title: "Return Filing & Ongoing Compliance",
        text: "We manage:",
        list: [
          "periodic GST return filing",
          "reconciliation and accuracy checks",
          "timely compliance tracking",
        ],
        extraInfo:
          "Helping businesses maintain consistent compliance discipline.",
      },
      {
        title: "Input Tax Credit (ITC) Management",
        text: "Our support includes:",
        list: [
          "ITC eligibility evaluation",
          "credit optimisation",
          "reversal and compliance advisory",
        ],
        extraInfo: "Reducing risk of credit denial during audits.",
      },
      {
        title: "Advisory on Complex GST Matters",
        text: "We advise on:",
        list: [
          "classification issues",
          "valuation disputes",
          "place of supply challenges",
          "structuring and restructuring under GST",
        ],
        extraInfo: "Providing clarity on complex and high-risk GST issues.",
      },
      {
        title: "Litigation & Representation Support",
        text: "We represent clients in:",
        list: [
          "reply drafting for notices & summons",
          "handling GST assessments & audits",
          "representation before GST authorities",
          "assistance in adjudication proceedings",
          "appeals before appellate authorities",
          "advance ruling representation",
          "strategy & documentation preparation",
          "support during investigations",
        ],
        extraInfo:
          "Strong defence, expert handling and complete documentation support throughout the dispute lifecycle.",
      },
    ],
    benefitsIntro: "How this service supports your business:",
    benefits: [
      "End-to-end GST compliance management",
      "Reduced risk of penalties and disputes",
      "Audit-ready documentation discipline",
      "Expert handling of notices and litigation",
      "Stronger GST governance and control",
    ],
    research:
      "With deep technical expertise and hands-on departmental experience, our GST team ensures businesses stay compliant, confident and protected in an increasingly data-driven GST environment.",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      projects={serviceData.benefits}
    />
  );
};

export default GSTComplianceLitigation;
